export { default as dealsService } from "./dealsService"
export * from "./dealsService"
